var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"content":_vm.$t('seeActivities')}},[_c('BaseButton',{staticClass:"btn-link btn-github btn-simple",attrs:{"icon":"","size":"sm","badge-value":_vm.activities},on:{"click":_vm.viewActivities}},[_c('i',{staticClass:"fas fa-file-alt"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }